<template>
  <img v-for="country of option?.exclusiveToCountries || []" :key="country" :src="getFlag(country)" class="ml-1 flag" />
  <img v-for="language of option?.exclusiveToLanguages || []" :key="language" :src="getFlag(undefined, language)" class="ml-1 language" />
</template>

<script setup lang="ts">
import { useTools } from '@/composables/useTools'
import { Option } from '@/models/Global'

defineProps<{
  option?: Option<string | number>
}>()
const { getFlag } = useTools()
</script>

<style lang="scss" scoped>
.flag {
  height: 1.25rem;
  width: auto;
}
</style>
